export default "__VITE_ASSET__BZtB0Zu4__"